var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadBalancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.169 12.942C11.826 12.278 13 10.664 13 8.77002C13 6.28502 10.985 4.27002 8.5 4.27002C6.015 4.27002 4 6.28502 4 8.77002C4 10.664 5.174 12.278 6.831 12.942",
    stroke: "#6A82D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.284 15.73C14.046 14.624 16 11.927 16 8.77002C16 4.62802 12.642 1.27002 8.5 1.27002C4.358 1.27002 1 4.62802 1 8.77002C1 11.927 2.954 14.624 5.716 15.73",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.5 10.27C9.32843 10.27 10 9.59845 10 8.77002C10 7.94159 9.32843 7.27002 8.5 7.27002C7.67157 7.27002 7 7.94159 7 8.77002C7 9.59845 7.67157 10.27 8.5 10.27Z",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadBalancer);
export default __webpack_public_path__ + "static/media/loadBalancer.6526c1065b7b761a2c81678cb2374148.svg";
export { ForwardRef as ReactComponent };